/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/images/logo.png";

function Main({ onClick }) {
  const [active] = useState();
  const [menuOpen, setMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(false);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  const handleMenuItemClick = () => {
    closeMenu();
    setIsDropdownOpen(!isDropdownOpen);
  };

  const HandleCategoryClick = (categoryId) => {
    setTimeout(() => {
      handleMenuItemClick();
    }, 200);
    onClick(categoryId);
  };

  return (
    <>
      {active && (
        <div
          className="menu-backdrop"
          style={{ opacity: "1", visibility: "visible" }}
        ></div>
      )}
      <header className={`fixed ${menuOpen ? "menu-open" : ""}`}>
        <div className="container-fluid">
          <nav className="navbar navbar-expand-lg">
            <Link className="navbar-brand" to="/">
              <img src={logo} alt="image" width={80} />
            </Link>
            <button
              className={`navbar-toggler ${menuOpen ? "open" : ""}`}
              type="button"
              onClick={toggleMenu}
            ></button>
            {/* <div
              className={`collapse navbar-collapse ${menuOpen ? "show" : ""}`}
              id="navbarSupportedContent"
            > */}
            {/* <ul className="navbar-nav ml-auto">
                <li className="nav-item has_dropdown">
                  <Link
                    className="nav-link"
                    to="#"
                    onClick={HandleCategoryClick}
                  >
                    Home
                  </Link>
                </li>
              </ul> */}
            {/* </div> */}
          </nav>
        </div>
      </header>
    </>
  );
}

export default Main;

